// Mirror of /app/backend/services/pricing.py — keep in sync when editing.
// The backend also returns `pricing` metadata on GET /courses so we mostly
// use that; this file exists for admin UIs (course editor dropdown) and as
// a safe client-side fallback.

export const TIER_CATALOG = [
  { tier: "tier_1", product_id: "ph.prepmaster.tier1_6mo", price_php: 499,  price_display: "₱499",    months: 6, label: "Starter" },
  { tier: "tier_2", product_id: "ph.prepmaster.tier2_6mo", price_php: 999,  price_display: "₱999",    months: 6, label: "Standard" },
  { tier: "tier_3", product_id: "ph.prepmaster.tier3_6mo", price_php: 2490, price_display: "₱2,490",  months: 6, label: "Pro" },
  { tier: "tier_4", product_id: "ph.prepmaster.tier4_6mo", price_php: 4990, price_display: "₱4,990",  months: 6, label: "Premium" },
];

export const TIER_BY_KEY = Object.fromEntries(TIER_CATALOG.map((t) => [t.tier, t]));
export const TIER_BY_PRODUCT = Object.fromEntries(TIER_CATALOG.map((t) => [t.product_id, t]));

// Dropdown options for the admin course editor.
export const TIER_OPTIONS = [
  { value: "",  label: "No price tier (use In-App Product ID below)" },
  ...TIER_CATALOG.map((t) => ({
    value: t.tier,
    label: `${t.label} — ${t.price_display} · 6 months`,
  })),
];
